import React from 'react';
import AWhiteSpace from 'antd-mobile/lib/white-space';



export default class WhiteSpace extends AWhiteSpace {}
